<template>
  <div class="cursor-pointer flex items-center" @click="goBack">
    <FontAwesomeIcon icon="chevron-left" class="mr-2" />
    <span>Back</span>
  </div>
</template>

<script>
export default {
  name: "BackButton",
  methods: {
    goBack() {
      this.$emit("click");
    }
  }
};
</script>
